const PRODAPIURL = "https://appapi.liquorconnect.com/odata/";
const PRODSTORAGEURL = "https://connectstorageprd.blob.core.windows.net";
const TESTAPIURL = "https://connectlogisticsapitst.azurewebsites.net/odata/";
const TESTSTORAGEURL = "https://connectstoragetst.blob.core.windows.net";
const isProd = (location.href.indexOf('liquorconnect.com') > -1 || location.href.indexOf('connectconsumerwebprd.azurewebsites.net') > -1) && (location.href.indexOf('ctest') < 0);
const PRODUCTCONTAINER = "productimages";
const COLLECTIONCONTAINER = "collectionimages";
const EVENTCONTAINER = "eventimages";
const AGENTCONTAINER = "agentimages";
const LICENSEECONTAINER = "licenseeimages";
const LOGOCONTAINER = "logos";
const CONSTS = {
    APIURL: isProd ? PRODAPIURL : TESTAPIURL,
    STORAGEURL: isProd ? PRODSTORAGEURL : TESTSTORAGEURL,
    PRODUCTCONTAINER: PRODUCTCONTAINER,
    COLLECTIONCONTAINER: COLLECTIONCONTAINER,
    EVENTCONTAINER: EVENTCONTAINER,
    AGENTCONTAINER: AGENTCONTAINER,
    LICENSEECONTAINER: LICENSEECONTAINER,
    LOGOCONTAINER: LOGOCONTAINER
};
export default CONSTS;
//# sourceMappingURL=consts.js.map